import Highway from '@dogstudio/highway';
import Infos from '../_modules/infos';
import Slideshow from '../_modules/slideshow';
import Grid from '../_modules/grid';
import Filters from '../_modules/filters';
import Menu from '../_modules/menu';

class Post extends Highway.Renderer {
  onEnter() {
    Infos.init();
    Slideshow.init();
    Grid.init();
    Filters.delete(["all", "all", "all"]);
    Menu.init();
  }
}

export default Post;
